export default __webpack_public_path__ + "static/City_York-0b565aad32509b379ba662382347a471.jpeg";